import { magicNumbers } from './magicNumbers';

export const convertToInternationalCurrencySystem = (
  labelValue,
  toFixed = 2
) => {
  const number = Math.abs(Number(labelValue));

  if (number >= magicNumbers.BILLION)
    return `${(number / magicNumbers.BILLION).toFixed(toFixed)}B`;

  if (number >= magicNumbers.MILLION)
    return `${(number / magicNumbers.MILLION).toFixed(toFixed)}M`;

  if (number >= magicNumbers.THOUSAND)
    return `${(number / magicNumbers.THOUSAND).toFixed(toFixed)}K`;

  return number;
};
